module.exports = __webpack_public_path__ + "static/media/map.ae1ce11d.png";